import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './Auth/AuthContext';
import logo from './Images/logo.png';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="app-loading" aria-label="Loading your workspace">
        <div className="app-loading-brand">
          <img src={logo} alt="Abdullah Traders" className="app-loading-logo" />
          <span className="loading-spinner" aria-hidden="true" />
        </div>
        <p>Loading your workspace…</p>
      </main>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

export function PublicRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return children;
}

export default ProtectedRoute;
